import * as React from "react";
import { INoSubLimitBannerProps } from "./NoSubLimitBanner.types";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { Image } from "react-bootstrap";
import {
  PopupTip,
  subscribeDataChange,
  unsubscribeDataChange,
  useFlowData,
} from "@adaptis/flow-components";
import { tips } from "../PopupTips/tips";
import _ from "lodash";
import "./NoSubLimitBanner.scss";

export default function NoSubLimitBanner(props: INoSubLimitBannerProps) {
  const [hideOnScroll, setHideOnScroll] = React.useState(false);
  const [petType, setPetType] = React.useState("dog");
  const { setData, getData } = useFlowData();

  const pets = getData("pets") ?? undefined;

  useScrollPosition(
    ({ currPos }) => {
      const hide = currPos.y >= 1;
      if (hide !== hideOnScroll) setHideOnScroll(hide);
    },
    [hideOnScroll],
    undefined,
    true,
    1,
  );

  function handlePetTypeChanged(dataPath: string, dataField: string, data: any) {
    if (dataField == "PetTypeChosenFirst") {
      setPetType(data);
    }
  }

  React.useEffect(() => {
    // Anything in here is fired on component mount.
    subscribeDataChange("SelectedPetType", handlePetTypeChanged);

    return () => {
      // Anything in here is fired on component unmount.
      unsubscribeDataChange("SelectedPetType");
    };
  }, []);

  const tip = props.details.tipName ? _.get(tips, props.details.tipName) : undefined;

  return (
    <div
      data-testid="NoSubLimitBanner"
      className={`${
        hideOnScroll ? "flc_no-sub-limit-banner z-index-0" : "flc_no-sub-limit-banner"
      } ${!petType || petType === "dog" ? "dog" : "cat"}`}
    >
      <div className="sublimit-container">
        <div className="no-sub-badge">
          {props.details && (
            <PopupTip className="ms-3" tip={tip}>
              <Image
                src="/images/no-sub-limits-new.svg"
                className="no-sub-limit-svg"
              />
            </PopupTip>
          )}
        </div>
        <div className="row-mobile-only">
          <div className="sublimit-row">
            <div className="tag-line-container">
              {props.details && props.details.tagLine1 && (
                <div className="tag-line">{props.details.tagLine1}</div>
              )}
              {props.details && props.details.tagLine2 && (
                <div className="tag-line">{props.details.tagLine2}</div>
              )}
            </div>
          </div>
          <div className="sublimit-row row-awards">
            <div className="content-item awards">
              <Image src={props.details.noSublimitFinderReview} />
            </div>
            {/* <div className="tips-label">
              <svg
                width="143"
                height="159"
                className="no-sub-limit-svg"
                viewBox="0 0 143 159"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M37.3993 12.9943H41.0945V29.5526H37.3993L29.4879 19.182V29.5526H25.7926V12.9943H29.2647L37.3993 23.6372V12.9943Z"
                  fill="white"
                />
                <path
                  d="M59.1246 27.2508C57.4381 28.8844 55.3797 29.7012 52.9244 29.7012C50.4692 29.7012 48.4107 28.8844 46.7243 27.2508C45.0378 25.6173 44.2194 23.5877 44.2194 21.1621C44.2194 18.7365 45.0626 16.707 46.7243 15.0734C48.3859 13.4398 50.4692 12.623 52.9244 12.623C55.3797 12.623 57.4381 13.4398 59.1246 15.0734C60.811 16.707 61.6294 18.7365 61.6294 21.1621C61.6294 23.5877 60.7862 25.6173 59.1246 27.2508V27.2508ZM57.8597 21.1621C57.8597 19.6771 57.3885 18.4395 56.4461 17.3752C55.5037 16.3357 54.338 15.8159 52.9492 15.8159C51.5604 15.8159 50.3948 16.3357 49.4523 17.3752C48.5099 18.4148 48.0387 19.6771 48.0387 21.1621C48.0387 22.6472 48.5099 23.8847 49.4523 24.9243C50.3948 25.9638 51.5604 26.4836 52.9492 26.4836C54.338 26.4836 55.5037 25.9638 56.4461 24.9243C57.3885 23.8847 57.8597 22.6472 57.8597 21.1621Z"
                  fill="white"
                />
                <path
                  d="M74.8977 16.2861C74.5505 16.5831 74.3769 16.9544 74.3769 17.4494C74.3769 17.9444 74.6001 18.3157 75.0217 18.588C75.4681 18.8602 76.4601 19.2067 78.0474 19.6028C79.6098 19.9988 80.8498 20.568 81.7179 21.3353C82.5859 22.1026 83.0323 23.2411 83.0323 24.7262C83.0323 26.2113 82.4619 27.424 81.3707 28.3398C80.2546 29.2556 78.7914 29.7259 76.981 29.7259C74.3521 29.7259 71.996 28.7606 69.888 26.8053L72.0952 24.1074C73.8809 25.6667 75.5425 26.4588 77.0554 26.4588C77.725 26.4588 78.2706 26.3103 78.6674 26.0132C79.0642 25.7162 79.2378 25.3202 79.2378 24.8252C79.2378 24.3302 79.0394 23.9342 78.6178 23.6372C78.1962 23.3401 77.4026 23.0431 76.1873 22.7461C74.2529 22.3006 72.8393 21.6818 71.9464 20.9641C71.0536 20.2215 70.6072 19.083 70.6072 17.4989C70.6072 15.9149 71.1776 14.7268 72.2937 13.8605C73.4345 13.019 74.8233 12.5735 76.5346 12.5735C77.6506 12.5735 78.7418 12.7715 79.8578 13.1428C80.9738 13.514 81.9411 14.0585 82.7595 14.7516L80.8746 17.4494C79.4362 16.3604 77.9482 15.8159 76.4105 15.8159C75.7905 15.8159 75.2945 15.9644 74.9473 16.2614L74.8977 16.2861Z"
                  fill="white"
                />
                <path
                  d="M90.5469 25.2707C91.1669 26.038 91.9853 26.4093 93.0269 26.4093C94.0686 26.4093 94.887 26.038 95.507 25.2707C96.127 24.5034 96.4246 23.4639 96.4246 22.1274V12.9943H100.12V22.2511C100.12 24.652 99.4503 26.4835 98.1359 27.7706C96.7966 29.0576 95.1102 29.7011 93.0269 29.7011C90.9437 29.7011 89.2573 29.0576 87.918 27.7706C86.5788 26.4835 85.9092 24.6272 85.9092 22.2511V12.9943H89.6045V22.1274C89.6045 23.4639 89.9021 24.5034 90.5221 25.2707H90.5469Z"
                  fill="white"
                />
                <path
                  d="M111.23 29.5279H103.964V12.9943H110.412C111.528 12.9943 112.495 13.118 113.314 13.3903C114.132 13.6625 114.752 14.0338 115.149 14.4793C115.893 15.3209 116.265 16.2861 116.265 17.3752C116.265 18.6622 115.843 19.6275 115 20.271C114.727 20.4938 114.529 20.6423 114.405 20.6918C114.306 20.7413 114.107 20.8403 113.81 20.9641C114.827 21.1868 115.645 21.6571 116.265 22.3501C116.885 23.0431 117.183 23.9342 117.183 24.9737C117.183 26.137 116.786 27.1518 115.992 28.0181C115.075 29.0329 113.487 29.5526 111.206 29.5526L111.23 29.5279ZM107.659 19.677H109.42C110.437 19.677 111.206 19.578 111.702 19.3553C112.198 19.1325 112.446 18.6622 112.446 17.9197C112.446 17.1772 112.223 16.7069 111.751 16.4594C111.28 16.2119 110.511 16.1129 109.42 16.1129H107.634V19.677H107.659ZM107.659 26.4093H110.189C111.255 26.4093 112.049 26.2855 112.57 26.0133C113.091 25.741 113.363 25.246 113.363 24.4787C113.363 23.7114 113.091 23.2164 112.52 22.9689C111.95 22.7214 111.057 22.5976 109.817 22.5976H107.634V26.4093H107.659Z"
                  fill="white"
                />
                <path
                  d="M32.5383 53.4867V36.9283H36.2336V50.1948H43.3018V53.4867H32.5383V53.4867Z"
                  fill="white"
                />
                <path d="M46.005 36.9283H49.7003V53.4867H46.005V36.9283V36.9283Z" fill="white" />
                <path
                  d="M68.648 43.0666L64.1591 52.1007H61.9518L57.4877 43.0666V53.4867H53.7924V36.9283H58.8021L63.0678 46.0119L67.3583 36.9283H72.3432V53.4867H68.648V43.0666V43.0666Z"
                  fill="white"
                />
                <path d="M76.4353 36.9283H80.1306V53.4867H76.4353V36.9283V36.9283Z" fill="white" />
                <path
                  d="M91.2164 40.146V53.4867H87.5212V40.146H82.8339V36.9531H95.9286V40.146H91.2412H91.2164Z"
                  fill="white"
                />
                <path
                  d="M102.352 40.245C102.005 40.542 101.831 40.9133 101.831 41.4083C101.831 41.9033 102.054 42.2746 102.476 42.5468C102.922 42.8191 103.914 43.1656 105.502 43.5616C107.064 43.9576 108.304 44.5269 109.172 45.2942C110.04 46.0615 110.486 47.2 110.486 48.6851C110.486 50.1701 109.916 51.3829 108.825 52.2987C107.709 53.2145 106.246 53.6847 104.435 53.6847C101.806 53.6847 99.4502 52.7195 97.3422 50.7641L99.5494 48.0663C101.335 49.6256 102.997 50.4176 104.51 50.4176C105.179 50.4176 105.725 50.2691 106.122 49.9721C106.518 49.6751 106.692 49.2791 106.692 48.7841C106.692 48.289 106.494 47.893 106.072 47.596C105.65 47.299 104.857 47.002 103.642 46.705C101.707 46.2595 100.293 45.6407 99.4006 44.9229C98.5078 44.1804 98.0614 43.0418 98.0614 41.4578C98.0614 39.8737 98.6318 38.6857 99.7478 37.8194C100.889 36.9779 102.277 36.5323 103.989 36.5323C105.105 36.5323 106.196 36.7304 107.312 37.1016C108.428 37.4729 109.395 38.0174 110.214 38.7104L108.329 41.4083C106.89 40.3192 105.402 39.7747 103.865 39.7747C103.245 39.7747 102.749 39.9232 102.401 40.2202L102.352 40.245Z"
                  fill="white"
                />
                <path
                  d="M81.2962 159H61.7038L60.2902 157.589V64.8721L61.7038 63.4861H81.2962L82.7099 64.8721V80.7622H79.9074V66.2829H63.1174V156.203H79.9074V142.293H82.7099V157.589L81.2962 159Z"
                  fill="white"
                />
                <path
                  d="M127.698 66.283H15.3019C6.86975 66.283 0 59.427 0 51.0117V15.2713C0 6.85601 6.86975 0 15.3019 0H127.698C136.13 0 143 6.85601 143 15.2713V51.0117C143 59.427 136.13 66.283 127.698 66.283ZM15.3019 2.79686C8.40739 2.79686 2.80246 8.39057 2.80246 15.2713V51.0117C2.80246 57.8924 8.40739 63.4861 15.3019 63.4861H127.698C134.593 63.4861 140.198 57.8924 140.198 51.0117V15.2713C140.198 8.39057 134.593 2.79686 127.698 2.79686H15.3019Z"
                  fill="white"
                />
                <path
                  d="M81.8666 97.6177C73.236 97.6177 68.3503 93.2615 68.1271 89.1529C67.9287 85.2422 71.7232 80.6138 83.0074 79.4505C86.8267 79.0545 90.1004 80.4653 92.01 83.3116C93.8453 86.0342 94.0437 89.4994 92.506 92.3457C91.4644 94.3258 88.662 97.6177 81.8418 97.6177H81.8666ZM83.305 82.2226C74.5752 83.1384 70.8056 86.2817 70.9296 88.9796C71.0784 91.826 75.1952 94.7961 81.8666 94.7961C85.8347 94.7961 88.7364 93.4595 90.0508 91.0092C91.0676 89.1034 90.9188 86.6778 89.7036 84.8709C88.3891 82.9156 86.0331 81.9751 83.3298 82.2473L83.305 82.2226Z"
                  fill="white"
                />
                <path
                  d="M84.0243 128.21C75.0217 128.21 68.5239 124.918 68.2015 120.215C67.8791 115.339 74.2776 111.552 85.3635 110.043C87.9923 109.696 90.3484 110.711 91.8612 112.889C93.8949 115.785 94.1429 120.116 92.4068 123.408C90.7948 126.502 87.8187 128.21 84.0243 128.21V128.21ZM85.7355 112.815C75.3193 114.226 70.8304 117.468 71.004 120.017C71.1776 122.666 76.0881 125.388 84.0243 125.388C87.4963 125.388 89.1332 123.606 89.9268 122.096C91.1668 119.72 91.018 116.527 89.5796 114.473C88.9348 113.557 87.7443 112.518 85.7603 112.79L85.7355 112.815Z"
                  fill="white"
                />
                <path
                  d="M83.1563 143.679C75.8897 143.679 70.3592 140.387 69.9872 135.833C69.6648 132.046 73.2361 127.344 84.1731 125.512C86.2316 125.165 88.0668 125.958 89.3812 127.74C91.5389 130.685 91.8365 135.784 90.0012 139.373C88.5876 142.145 86.1572 143.679 83.1563 143.679V143.679ZM84.6443 128.284C75.5673 129.794 72.5913 133.16 72.7897 135.586C73.0129 138.135 76.7081 140.858 83.1563 140.858C85.1155 140.858 86.5788 139.942 87.4964 138.11C88.8356 135.487 88.662 131.502 87.1244 129.398C86.43 128.482 85.6363 128.111 84.6443 128.259V128.284Z"
                  fill="white"
                />
                <path
                  d="M84.0739 112.74H84.0243C74.7737 112.74 66.9615 108.211 66.9615 102.914C66.9615 100.489 68.7719 94.8208 85.4627 94.8208H85.5619C89.406 94.8208 92.7541 96.6524 94.5149 99.6967C96.0525 102.37 96.1021 105.439 94.6389 107.939C93.5973 109.721 90.8444 112.74 84.0987 112.74H84.0739ZM85.4627 97.6424C74.6249 97.6424 69.7887 100.291 69.7887 102.939C69.7887 105.785 75.3441 109.919 84.0491 109.944H84.0987C88.0668 109.944 90.9436 108.731 92.2085 106.553C93.1509 104.919 93.1013 102.89 92.0845 101.108C90.8196 98.9047 88.4388 97.6424 85.5619 97.6424H85.4875H85.4627Z"
                  fill="white"
                />
                <path
                  d="M17.782 105.191C7.16736 105.191 1.41363 104.276 1.19043 104.226L1.63684 101.454C1.63684 101.454 7.41537 102.37 17.782 102.37C26.983 102.37 30.1575 99.1027 34.572 94.5981C39.4081 89.6479 45.4594 83.4602 61.3318 79.401L62.0262 82.1236C46.8979 85.9847 41.1689 91.8507 36.5808 96.5534C32.0423 101.182 28.1486 105.191 17.7572 105.191H17.782Z"
                  fill="white"
                />
                <path
                  d="M37.9201 119.399V116.602C55.9749 116.602 60.315 103.508 60.3398 103.385L63.0182 104.226C62.9686 104.375 58.0085 119.399 37.8953 119.399H37.9201Z"
                  fill="white"
                />
                <path
                  d="M56.074 148.679C46.5754 148.679 42.8057 146.154 39.1105 143.679C33.7783 140.115 28.2726 136.427 1.66162 141.501L1.14081 138.754C28.8926 133.432 34.8944 137.467 40.6977 141.353C44.9634 144.199 48.9563 146.897 62.919 145.486L63.1918 148.283C60.5133 148.555 58.1573 148.679 56.074 148.679V148.679Z"
                  fill="white"
                />
              </svg>

              {props.details && <PopupTip className="ms-3" tip={tip} />}
              <div className="tip-label">{props.details.tipLabel}</div>
            </div> */}
          </div>
        </div>
        <div className="row-desktop">
          <div className="sublimit-row">
            <div className="content-item mobile-container">
              <div className="sublimit-row">
                <div className="tag-line-container">
                  {props.details && props.details.tagLine1 && (
                    <div className="tag-line">{props.details.tagLine1}</div>
                  )}
                  {props.details && props.details.tagLine2 && (
                    <div className="tag-line">{props.details.tagLine2}</div>
                  )}
                </div>
              </div>
              <div className="sublimit-row">
                <div className="tips-label">
                  {/* <Image src={props.details.noSublimitSVG} className="no-sub-limit-svg" />
                  {props.details && <PopupTip className="ms-3" tip={tip} />} */}
                  <div className="tip-label">{props.details.tipLabel}</div>
                </div>
                <div className="copy-label">Award winning pet insurance coverage</div>
              </div>
            </div>
          </div>
          <div className="sublimit-row">
            <div className="content-item awards">
              <Image src={props.details.noSublimitFinderReview} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
